import ProductCard from 'catalog/product/components/product-card/card-item.component';
import clsx from 'clsx';
import Container from 'common/components/container.component';
import IslandComponent from 'common/components/island.component';
import Loading from 'common/components/loading.component';
import React from 'react';
import { Auth } from 'store/models/auth.model';
import { Cart } from 'store/models/cart.model';
import { HomeIsland } from 'store/models/setting.model';
import { User } from 'store/models/user.model';
import styles from './style.module.scss';

type HomeContainerProps = {
  homeIslands: HomeIsland[];
  cart: Cart;
  user: User;
  auth: Auth;
  rotate: boolean;
};

const islandKey = (island: HomeIsland, index: number): string => island.slug || `${island.sectionName}-${index}`;

const HomeContainer: React.FC<HomeContainerProps> = ({ homeIslands = [], cart, user, auth, rotate }) => {
  const renderHomeIslandItems = (homeIsland: HomeIsland) => {
    return (homeIsland.products ?? []).map((product) => (
      <div
        key={product._id}
        className={clsx(styles['product-item-wrapper'], homeIsland.showCarousel !== false && styles['product-item-wrapper--carousel'])}
      >
        <ProductCard product={product} cart={cart} user={user} auth={auth} hoverable />
      </div>
    ));
  };

  const renderHomeIslands = () =>
    homeIslands.map((homeIsland, index) => {
      const key = islandKey(homeIsland, index);
      return <IslandComponent key={key} island={homeIsland} items={renderHomeIslandItems(homeIsland)} />;
    });

  return (
    <Container>
      <Loading rotate={rotate}>{renderHomeIslands()}</Loading>
    </Container>
  );
};

export default HomeContainer;
